import { useContext, useEffect } from "react"
import { SavedIcon } from '../../StateManagment/SavedIcon'

// Google-style snackbar: the single global notice at the bottom of the view.
// Every save (setSaved('flex')) shows "Opgeslagen"; a one-off custom message
// (setSavedMessage('...')) takes precedence. Auto-dismisses after 4 seconds,
// the Material Design guideline for snackbars.
const DISMISS_AFTER_MS = 4000;

const Snackbar = () => {
    const [saved, setSaved, savedMessage, setSavedMessage] = useContext(SavedIcon)

    const visible = saved === 'flex' || !!savedMessage;

    useEffect(() => {
        if (!visible) return;
        const timer = setTimeout(() => {
            setSaved('none');
            setSavedMessage('');
        }, DISMISS_AFTER_MS);
        return () => clearTimeout(timer);
    }, [visible, saved, savedMessage, setSaved, setSavedMessage]);

    if (!visible) return null;

    return (
        <div id='snackbar-container' role='status'>
            <p>{savedMessage || 'Opgeslagen'}</p>
        </div>
    )
}

export default Snackbar
